<template>
  <header class="header">

    <header-mobile-menu :is-open="isMenuOpen" :items="visibleHeaderList" @close="closeMenu"/>

    <div class="header__top container">
      <router-link :to="{ name: 'welcome.index' }" class="header__logo" />

      <header-burger :is-open="isMenuOpen" @toggle="toggleMenu"/>

      <nav class="header__nav">
        <router-link
          v-for="item in visibleHeaderList"
          :key="item.linkName"
          :to="{ name: item.linkName }"
          class="link"
          active-class="link--active"
          exact-active-class="link--active"
        >
          {{ item.title }}
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref, computed } from 'vue'
import HeaderMobileMenu from '@widgets/header/ui/HeaderMobileMenu'
import HeaderBurger from '@widgets/header/ui/HeaderBurger'
import { useAbilities } from '@shared/lib'

const isMenuOpen = ref(false)
const { canViewManage, canViewPermissions, canViewComponents, canViewStatistics} = useAbilities()

const headerList = [
  { title: 'Проекты',    linkName: 'projects.index'     },
  { title: 'Новости',    linkName: 'news.index'         },
  { title: 'Документы',  linkName: 'documents.index'    },
  { title: 'Статистика', linkName: 'statistics.index',  condition: canViewStatistics },
  { title: 'Компоненты', linkName: 'components.index',  condition: canViewComponents },
  { title: 'Управление', linkName: 'manage.index',      condition: canViewManage },
  { title: 'Права',      linkName: 'permissions.index', condition: canViewPermissions },
]

const visibleHeaderList = computed(() =>
  headerList.filter(item => item.condition === undefined || item.condition.value)
)

const toggleMenu = () => isMenuOpen.value = !isMenuOpen.value
const closeMenu = () => isMenuOpen.value = false
</script>